// extracted by mini-css-extract-plugin
export default {"fallback":"HhWBps","component":"uITA8n","componentMob":"sdBZPh"};